module.exports = __webpack_public_path__ + "media/blogs/hero_image_mobile-8b98521e.png";